<template>
  <div class="case-show-container">
    <seg-carousel
      :item-top="false"
      height="500px"
      style="overflow-y: hidden;"
      :modal-shadow="false"
      :imgs="[{'src': banner}]"
      indicator-position="none"
    />
    <seg-main
      width="1300px"
      style="margin-top: 0"
    >
      <template v-slot:title-text>
        <span style="color: #343434;">{{ pageCate.title }}</span>
      </template>
      <template v-slot:title-text-en>
        <span style="color: #505050;">{{ pageCate.eng }}</span>
      </template>
      <template v-slot:back-word>
        <span style="color:#f6f6f6;">ACHIEVEMENT DISPLAY</span>
      </template>
      <div>
        <case-show-list-item
          v-for="item of result"
          :key="item.id"
          :img-src="item.coverPicKey"
        >
          <template v-slot:intro-start-word>
            {{ item|introduceOrContent|removeTagAndCutTop|transHtmlEntity|showIntroduce }}
          </template>
          <template v-slot:title>
            <div
              class="title-block"
              @click="$router.push({name: 'NewsFocusDetail', params: {articleId: item.id}, query: {from: $route.path}})"
            >
              <div>{{ item.title }}</div>
              <div class="time-block">
                {{ item.date || item.publishDate }}
              </div>
            </div>
          </template>
          <template v-slot:content>
            <div v-if="item.content">
              {{ item|introduceOrContent|removeTagAndCutTop|transHtmlEntity }}
            </div>
          </template>
        </case-show-list-item>
        <el-pagination
          background
          :current-page.sync="page.result.curPage"
          layout="prev, pager, next"
          :total="page.result.total"
          @current-change="getResult()"
        />
      </div>
    </seg-main>
  </div>
</template>

<script>
import SegCarousel from '@/components/indexTopCarousel/segCarousel';
import SegMain from '@/components/segPart/segMain';
import CaseShowListItem from '@/components/caseShowList/caseShowListItem';
import {getArticle} from '@/api';
import dayjs from 'dayjs';
import {menu} from '@/constant';

export default {
  name: 'CateShow',
  components: {
    CaseShowListItem, SegMain, SegCarousel,
  },
  filters: {
    showIntroduce: function (val) {
      return val ? '【简要介绍】' : ''
    }
  },
  props: {
    cateId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      page: {
        result: {
          total: 0,
          curPage: 1
        }
      },
      result: []
    };
  },
  computed: {
    menu: function () {
      return menu[2].children
    },
    pageCate: function () {
      return this.menu.filter(item => item.url.split('/').pop() === this.cateId)[0]
    },
    banner: function () {
      const map = {
        21: require('@/assets/img/news-focus/top-banner-2.png'),
        22: require('@/assets/img/news-focus/top-banner-1.png'),
        23: require('@/assets/img/news-focus/top-banner.png'),
      }
      return map[this.cateId]
    }
  },
  watch: {
    cateId: {
      handler() {
        this.getResult()
      },
      immediate: true
    }
  },
  methods: {
    getResult() {
      getArticle({
        categories_id: '[' + this.cateId +']',
        page: this.page.result.curPage,
        title: this.$route.query.keyword || ''
      }).then(res => {
        if(res.data.success) {
          this.result = res.data.data.map(item => {
            return {
              ...JSON.parse(item.content),
              id: item.id,
              publishDate: dayjs(item.confirmed_at).format('YYYY-MM-DD')
            }
          }).sort((firElem,secElem) => {
            return parseInt(firElem.sort) - parseInt(secElem.sort)
          })
        }
        this.page.result.total = res.data.total
      })
    }
  }
};
</script>

<style scoped lang="less">
.time-block {
  float: right;
  font-size: 12px;
  font-weight: normal;
  min-width: 67px;
}

.title-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0!important;
  * {
    margin: 0!important;
  }
}
</style>
